export default "__VITE_ASSET__D8gNGp0V__"